import { Fragment } from 'react';
import { LinkableEntityType } from '@api';
import { LinkableEntity } from './LinkableEntity';

type LinkableEntityListPropsType = {
  entities: LinkableEntityType[];
};

export const LinkableEntityList: React.FC<LinkableEntityListPropsType> = ({
  entities,
}) => (
  <>
    {entities.map((entity, index) => (
      <Fragment key={`${entity.type}-${entity.id}`}>
        {index > 0 ? ', ' : null}
        <LinkableEntity linkableEntity={entity} />
      </Fragment>
    ))}
  </>
);
